import React, { useEffect, useState } from 'react';

import cs from 'classnames';

import { ia } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';
import { usePacketBuilderContext } from 'lib/context/PacketBuilder/PacketBuilderContext';

import Input from 'components/shared/Input/Input';
import StepsChart from 'components/shared/StepsChart/StepsChart';
import ErrorMessage from 'components/shared/ErrorMessage/ErrorMessage';
import ErrorBoundary, { withErrorBoundary } from 'components/shared/Error/Boundary';

import { getCurrentWithoutHidden, getStepsLeft } from '../lib/helpers';

import ItemList from './ItemList';

const Services = ({ currentBreadcrumb, servicesList }) => {
  const { breadCrumbs, setSearchTerm, setEnableNextTo, setEnableSubmit, formik } =
    usePacketBuilderContext();
  const [selectedLength, setSelectedLength] = useState(formik.values?.service_ids?.length);
  const { device } = useUIContext();

  const currentBreadcrumbStep = getCurrentWithoutHidden(breadCrumbs, currentBreadcrumb);
  const getBreadcrumbsLeft = getStepsLeft(breadCrumbs, currentBreadcrumb);

  useEffect(() => {
    if (selectedLength == 0) {
      setEnableSubmit(false);
      setEnableNextTo(false);
    } else {
      setEnableSubmit(true);
      setEnableNextTo(true);
    }
  }, [selectedLength]);

  const chartData = [
    { name: 'completed', value: currentBreadcrumbStep },
    { name: 'not-completed', value: getBreadcrumbsLeft }
  ];

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div>
        <StepsChart
          chartData={chartData}
          title="Choose service(s)"
          description="This form packet will be sent each time the service(s) selected are scheduled."
          innerText={`${currentBreadcrumbStep}/${currentBreadcrumbStep + getBreadcrumbsLeft}`}
        />
        <div className="px-9 pt-10">
          <div className="flex items-center justify-between ">
            <p className="text-sm font-500 text-primary-900">Select from the list of services.</p>
            <div className="flex items-center gap-3">
              <p className={cs(selectedLength ? 'text-primary-900' : 'text-neutral-500')}>
                {selectedLength} selected
              </p>
              <Input
                placeholder="Search services"
                icon="search-linear"
                rounded="full"
                width={device === 'tablet-sm' ? '250px' : '280px'}
                onChange={(e) =>
                  setSearchTerm((prevState) => ({
                    ...prevState,
                    services: e.target.value
                  }))
                }
              />
            </div>
          </div>
          <div className="mt-[21px]">
            {ia(servicesList?.services) &&
              servicesList?.services?.map((service, index) => (
                <ItemList
                  key={index}
                  item={service}
                  options="service_ids"
                  setSelectedLength={setSelectedLength}
                />
              ))}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default withErrorBoundary(Services);
